export enum OnboardingLogType {
  INFO = 0,
  WARNING = 1,
  ERROR = 2,
  DEBUG = 3
}
